import { createNamespacedHelpers } from 'vuex'

const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')
const casparKeys = [
  'caspar_psoriase',
  'caspar_distrofia_ungueal',
  'caspar_fator_reumatoide_negativo',
  'caspar_dactilite',
  'caspar_evidencia_neoformacao_ossea',
]
export default {
  computed: {
    ...attendanceGettersMap(['getPhaseDataByKey']),
    computedPest() {
      const pestData = this.getPhaseDataByKey('investigacao_articular')?.pest
      if (!pestData || Object.keys(pestData).some((key) => pestData[key].value == null)) {
        return '?'
      }

      return Object.keys(pestData).reduce((previousValue, key) => {
        return previousValue + (!pestData[key].value ? 0 : 1)
      }, 0)
    },
    computedCaspar() {
      const casparData = this.getPhaseDataByKey('investigacao_articular')?.caspar
      if (
        !casparData ||
        casparKeys.some((key) => casparData[key].value == null) ||
        (casparData['caspar_psoriase'].value && !casparData['caspar_condicao_psoriase'].value)
      ) {
        return '?'
      }

      return casparKeys.reduce((previousValue, key) => {
        return (
          previousValue +
          (!casparData[key].value
            ? 0
            : key === 'caspar_psoriase'
            ? casparData['caspar_condicao_psoriase'].value === 'ATUAL'
              ? 2
              : 1
            : 1)
        )
      }, 0)
    },
    computedPasi() {
      const phaseData = this.getPhaseDataByKey('pasi_bsa')
      return phaseData?.pasi == null ? '?' : phaseData?.pasi
    },
    computedBsa() {
      const phaseData = this.getPhaseDataByKey('pasi_bsa')
      return phaseData?.bsa == null ? '?' : phaseData?.bsa
    },
    computedDlqi() {
      const phaseData = this.getPhaseDataByKey('dlqi')
      return phaseData?.dlqi?.value == null ? '?' : phaseData?.dlqi?.value
    },
    haveArtrite() {
      const phaseData = this.getPhaseDataByKey('investigacao_articular')
      return phaseData?.diagnostico_artrite_psoriatica.value == null ||
        phaseData?.diagnostico_artrite_psoriatica.value == 'NAO_SEI'
        ? '?'
        : phaseData?.diagnostico_artrite_psoriatica.value == 'SIM'
        ? 'Sim'
        : 'Não'
    },
    affectedAreasText() {
      const areasAfetadas = this.getPhaseDataByKey('areas_afetadas')?.areas_afetadas || {}
      if (Object.values(areasAfetadas).filter((a) => a.selected).length === 0) {
        return 'atualmente sem lesões'
      }

      return [
        ...new Set(
          Object.values(areasAfetadas)
            .filter((a) => a.selected)
            .map((a) => a.classKey.toLowerCase()),
        ),
      ]
    },
    affectedAreasTextV2() {
      const areasAfetadas = this.getPhaseDataByKey('areas_afetadas')?.areas_afetadas || {}
      if (Object.values(areasAfetadas).filter((a) => a.selected).length === 0) {
        return 'atualmente sem lesões'
      }

      return [
        ...new Set(
          Object.values(areasAfetadas)
            .filter((a) => a.selected)
            .map((a) => `\n - ${a.classKey.toLowerCase()}`),
        ),
      ]
    },
    diseaseLevelText() {
      if (
        Number(this.computedPasi) >= 10 ||
        Number(this.computedBsa) >= 10 ||
        Number(this.computedDlqi) >= 10 ||
        this.getPhaseDataByKey('areas_afetadas')?.medicamentos_previos_mais_de_3_meses === 'SIM_SEM_MELHORIA'
      ) {
        return 'moderada a grave'
      }
      return 'leve'
    },
    diseaseLevelTextV2() {
      if (
        Number(this.computedPasi) >= 10 ||
        Number(this.computedBsa) >= 10 ||
        Number(this.computedDlqi) >= 10 ||
        this.getPhaseDataByKey('areas_afetadas')?.medicamentos_previos_mais_de_3_meses === 'SIM_SEM_MELHORIA'
      ) {
        return 'moderada a grave'
      }
      return ''
    },
    cid() {
      return this.getPhaseDataByKey('lme')?.cid?.code || ''
    },
    diagnosisTimeText() {
      if (!this.getPhaseDataByKey('dados_especificos') || !this.getPhaseDataByKey('dados_especificos')?.value) {
        return ''
      }
      const diagnosisYear = parseInt(this.getPhaseDataByKey('dados_especificos')?.ano_diagnostico_psoriase?.value)
      if (diagnosisYear) {
        const difference = new Date().getFullYear() - diagnosisYear

        if (difference === 0) {
          return ', diagnosticado nesse ano, '
        }

        if (difference === 1) {
          return `, há ${difference} ano, `
        }

        return `, há ${difference} anos, `
      }
      return ''
    },
  },
}
